import React, { useEffect, useState, useContext } from 'react';
import { X, Loader2, ArrowLeft, Mail } from 'lucide-react';
import { authService } from '../../services/auth';
import { ToastContext } from '../../App';
const LoginModal = ({
  isOpen,
  onClose,
  onRegisterClick,
  pendingAnalysis = false,
  isRelogin = false
}) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [isResetEmailSent, setIsResetEmailSent] = useState(false);
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState('');
  const [error, setError] = useState('');
  const [isMagicLinkView, setIsMagicLinkView] = useState(false);
  const [magicLinkSent, setMagicLinkSent] = useState(false);
  const [magicLinkEmail, setMagicLinkEmail] = useState('');
  const {
    addToast
  } = useContext(ToastContext);
  useEffect(() => {
    if (isOpen) {
      // Clear error messages when modal is opened
      setError('');
    }
  }, [isOpen]);
  if (!isOpen) return null;
  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      await authService.login(email, password);
      setIsLoading(false);
      onClose();
      // Show toast notification
      addToast('success', 'Login realizado com sucesso!');
      // Dispatch storage event to update authentication state
      window.dispatchEvent(new Event('storage'));
    } catch (error) {
      setIsLoading(false);
      setError(error.response?.data?.message || 'Erro ao fazer login. Verifique suas credenciais.');
    }
  };
  const handleForgotPasswordSubmit = async e => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      // Use the correct method for password reset
      await authService.requestPasswordReset(forgotPasswordEmail);
      setIsLoading(false);
      setIsResetEmailSent(true);
    } catch (error) {
      setIsLoading(false);
      setError(error.response?.data?.message || 'Erro ao solicitar redefinição de senha. Verifique seu email.');
    }
  };
  const handleMagicLinkSubmit = async e => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      await authService.requestMagicLink(magicLinkEmail);
      setIsLoading(false);
      setMagicLinkSent(true);
      // Show toast notification
      addToast('success', 'Link de acesso enviado com sucesso!');
    } catch (error) {
      setIsLoading(false);
      setError(error.response?.data?.message || 'Erro ao enviar magic link. Verifique seu email.');
    }
  };
  const handleBackToLogin = () => {
    setIsForgotPassword(false);
    setIsResetEmailSent(false);
    setIsMagicLinkView(false);
    setMagicLinkSent(false);
    setError('');
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" data-id="element-28">
      <div className="relative w-full max-w-md p-6 mx-4 bg-white rounded-lg shadow-xl flex flex-col" data-id="element-29">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700" aria-label="Close" disabled={isLoading} data-id="element-30">
          <X size={20} data-id="element-31" />
        </button>
        <div className="flex flex-col" data-id="element-32">
          {isForgotPassword ? <>
              <div className="flex items-center mb-6" data-id="element-33">
                <button onClick={handleBackToLogin} className="mr-2 text-gray-500 hover:text-gray-700" disabled={isLoading} data-id="element-34">
                  <ArrowLeft size={20} data-id="element-35" />
                </button>
                <h2 className="text-2xl font-bold text-gray-900" data-id="element-36">
                  Recuperar senha
                </h2>
              </div>
              {isResetEmailSent ? <div className="flex flex-col justify-center space-y-4" data-id="element-37">
                  <div className="p-4 bg-green-50 text-green-800 rounded-md" data-id="element-38">
                    <p data-id="element-39">
                      Se o email existir, enviamos um link de recuperação de
                      senha para <strong data-id="element-40">{forgotPasswordEmail}</strong>.
                    </p>
                    <p className="mt-2" data-id="element-41">
                      Verifique sua caixa de entrada e siga as instruções para
                      redefinir sua senha.
                    </p>
                  </div>
                  <button onClick={() => {
              handleBackToLogin();
              addToast('success', 'Link de recuperação enviado com sucesso!');
            }} className="w-full py-2 text-white bg-[#1649ff] rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" data-id="element-42">
                    Voltar para o login
                  </button>
                </div> : <form onSubmit={handleForgotPasswordSubmit} className="flex flex-col" data-id="element-43">
                  <div data-id="element-44">
                    <p className="text-sm text-gray-600 mb-4" data-id="element-45">
                      Digite seu e-mail abaixo. Enviaremos um link para que você
                      possa criar uma nova senha.
                    </p>
                    {error && <div className="p-3 bg-red-50 text-red-700 rounded-md mb-4" data-id="element-46">
                        {error}
                      </div>}
                    <div data-id="element-47">
                      <label htmlFor="forgotPasswordEmail" className="block mb-2 text-sm font-medium text-gray-700" data-id="element-48">
                        Email
                      </label>
                      <input type="email" id="forgotPasswordEmail" value={forgotPasswordEmail} onChange={e => setForgotPasswordEmail(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1649ff]" required disabled={isLoading} autoComplete="username" data-id="element-49" />
                    </div>
                  </div>
                  <button type="submit" className="w-full py-2 mt-6 text-white bg-[#1649ff] rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 flex items-center justify-center" disabled={isLoading} data-id="element-50">
                    {isLoading ? <>
                        <Loader2 size={18} className="mr-2 animate-spin" data-id="element-51" />
                        Processando...
                      </> : 'Recuperar senha'}
                  </button>
                </form>}
            </> : isMagicLinkView ? <>
              <div className="flex items-center mb-6" data-id="element-52">
                <button onClick={handleBackToLogin} className="mr-2 text-gray-500 hover:text-gray-700" disabled={isLoading} data-id="element-53">
                  <ArrowLeft size={20} data-id="element-54" />
                </button>
                <h2 className="text-2xl font-bold text-gray-900" data-id="element-55">
                  Login com Magic Link
                </h2>
              </div>
              {magicLinkSent ? <div className="flex flex-col justify-center space-y-4" data-id="element-56">
                  <div className="p-4 bg-green-50 text-green-800 rounded-md" data-id="element-57">
                    <p data-id="element-58">
                      Enviamos um link de acesso para{' '}
                      <strong data-id="element-59">{magicLinkEmail}</strong>.
                    </p>
                    <p className="mt-2" data-id="element-60">
                      Verifique sua caixa de entrada e clique no link para fazer
                      login.
                    </p>
                  </div>
                  <button onClick={handleBackToLogin} className="w-full py-2 text-white bg-[#1649ff] rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" data-id="element-61">
                    Voltar para o login
                  </button>
                </div> : <form onSubmit={handleMagicLinkSubmit} className="flex flex-col" data-id="element-62">
                  <div data-id="element-63">
                    <p className="text-sm text-gray-600 mb-4" data-id="element-64">
                      Digite seu e-mail abaixo. Enviaremos um link para que você
                      possa acessar sua conta sem senha.
                    </p>
                    {error && <div className="p-3 bg-red-50 text-red-700 rounded-md mb-4" data-id="element-65">
                        {error}
                      </div>}
                    <div data-id="element-66">
                      <label htmlFor="magicLinkEmail" className="block mb-2 text-sm font-medium text-gray-700" data-id="element-67">
                        Email
                      </label>
                      <input type="email" id="magicLinkEmail" value={magicLinkEmail} onChange={e => setMagicLinkEmail(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1649ff]" required disabled={isLoading} autoComplete="username" data-id="element-68" />
                    </div>
                  </div>
                  <button type="submit" className="w-full py-2 mt-6 text-white bg-[#1649ff] rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 flex items-center justify-center" disabled={isLoading} data-id="element-69">
                    {isLoading ? <>
                        <Loader2 size={18} className="mr-2 animate-spin" data-id="element-70" />
                        Processando...
                      </> : 'Enviar Magic Link'}
                  </button>
                </form>}
            </> : <>
              <h2 className="mb-6 text-2xl font-bold text-center text-gray-900" data-id="element-71">
                {isRelogin ? 'Faça login novamente' : 'Entrar'}
              </h2>
              <div className="flex flex-col" data-id="element-72">
                {pendingAnalysis && <div className="mb-4 p-3 bg-blue-50 text-blue-800 rounded-md" data-id="element-73">
                    Faça login para continuar com a análise da sua marca.
                  </div>}
                {error && <div className="mb-4 p-3 bg-red-50 text-red-700 rounded-md" data-id="element-74">
                    {error}
                  </div>}
                <form onSubmit={handleSubmit} className="space-y-4 px-0.5" data-id="element-75">
                  <div data-id="element-76">
                    <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-700" data-id="element-77">
                      Email
                    </label>
                    <input type="email" id="email" name="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1649ff] text-gray-900" required disabled={isLoading} autoComplete="username" data-id="element-78" />
                  </div>
                  <div data-id="element-79">
                    <label htmlFor="password" className="block mb-2 text-sm font-medium text-gray-700" data-id="element-80">
                      Senha
                    </label>
                    <input type="password" id="password" name="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1649ff] text-gray-900" required disabled={isLoading} autoComplete="current-password" data-id="element-81" />
                  </div>
                  <div className="flex justify-between items-center" data-id="element-82">
                    <button type="button" onClick={() => setIsForgotPassword(true)} className="text-sm text-[#1649ff] hover:underline" disabled={isLoading} data-id="element-83">
                      Esqueceu a senha?
                    </button>
                    <button type="button" onClick={() => setIsMagicLinkView(true)} className="text-sm text-[#1649ff] hover:underline flex items-center" disabled={isLoading} data-id="element-84">
                      <Mail size={14} className="mr-1" data-id="element-85" />
                      Login com Magic Link
                    </button>
                  </div>
                </form>
                <div className="mt-6" data-id="element-86">
                  <button type="submit" onClick={handleSubmit} className="w-full py-2 text-white bg-[#1649ff] rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 flex items-center justify-center" disabled={isLoading} data-id="element-87">
                    {isLoading ? <>
                        <Loader2 size={18} className="mr-2 animate-spin" data-id="element-88" />
                        Processando...
                      </> : isRelogin ? 'Fazer login' : 'Entrar'}
                  </button>
                  <div className="mt-4 text-center" data-id="element-89">
                    <p className="text-sm text-gray-600" data-id="element-90">
                      Não tem uma conta?{' '}
                      <button onClick={onRegisterClick} className="text-[#1649ff] hover:underline" disabled={isLoading} data-id="element-91">
                        Criar conta
                      </button>
                    </p>
                  </div>
                </div>
              </div>
            </>}
        </div>
      </div>
    </div>;
};
export default LoginModal;